import { render, staticRenderFns } from "./PublishAction.vue?vue&type=template&id=ae20649a&scoped=true&"
import script from "./PublishAction.vue?vue&type=script&lang=ts&"
export * from "./PublishAction.vue?vue&type=script&lang=ts&"
import style0 from "./PublishAction.vue?vue&type=style&index=0&id=ae20649a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae20649a",
  null
  
)

export default component.exports